import { ACTIONS } from '../const';
import { combineReducers } from './utils';
import markupHandler from './markup/markup.js';

export default combineReducers({
    markup: markupHandler,
    unansweredCounts(state = {}, action) {
        if (action.type == ACTIONS.UNANSWERED_COUNT) {
            const { contentId, total } = action.payload;
            return {
                ...state,
                [contentId]: total,
            };
        }
        return state;
    },
    noteCounts(state = {}, action) {
        if (action.type == ACTIONS.NOTE_COUNT) {
            const { contentId, total } = action.payload;
            return {
                ...state,
                [contentId]: total,
            };
        }
        return state;
    },
});



// WEBPACK FOOTER //
// ./src/reducers/markup.js